import { createActions } from 'redux-actions';
import * as types from 'actions/notifications/types';

export default createActions({}, ...Object.values(types));
